import React, { useEffect, useRef, useState } from "react";
import { GOOGLE_CLIENT_ID } from '../../config';
import './GoogleSignIn.scss';

const GIS_SRC = 'https://accounts.google.com/gsi/client';

function loadGisScript() {
    if (window.google?.accounts?.id) return Promise.resolve();
    return new Promise((resolve, reject) => {
        const existing = document.querySelector(`script[src="${GIS_SRC}"]`);
        if (existing) {
            existing.addEventListener('load', () => resolve());
            existing.addEventListener('error', () => reject(new Error('GIS load error')));
            return;
        }
        const script = document.createElement('script');
        script.src = GIS_SRC;
        script.async = true;
        script.defer = true;
        script.onload = () => resolve();
        script.onerror = () => reject(new Error('GIS load error'));
        document.head.appendChild(script);
    });
}

export default function GoogleSignIn({ onCredential, text = 'signup_with' }) {
    const containerRef = useRef(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!GOOGLE_CLIENT_ID) return;

        let cancelled = false;
        loadGisScript()
            .then(() => {
                if (cancelled || !containerRef.current || !window.google?.accounts?.id) return;
                window.google.accounts.id.initialize({
                    client_id: GOOGLE_CLIENT_ID,
                    callback: (response) => {
                        if (response?.credential) onCredential(response.credential);
                    },
                });
                window.google.accounts.id.renderButton(containerRef.current, {
                    type: 'standard',
                    theme: 'outline',
                    size: 'large',
                    text,
                    shape: 'rectangular',
                    width: 280,
                    locale: 'ar',
                });
            })
            .catch(() => { if (!cancelled) setError('تعذر تحميل تسجيل الدخول بـ Google'); });

        return () => { cancelled = true; };
    }, [onCredential, text]);

    if (!GOOGLE_CLIENT_ID) return null;

    return (
        <div className='gsi-wrapper'>
            <div ref={containerRef} className='gsi-button-host' />
            {error && <small className='gsi-error'>{error}</small>}
        </div>
    );
}
